import { all, put, takeLatest } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'
import { serverFailure } from 'data/actions'

import { FlashNoticeVariant } from '../presentational'
import { showFlashNotice } from './actions'

export function* flashNoticeSaga() {
  yield all([takeLatest(getType(serverFailure), displayServerErrorFlash)])
}

function* displayServerErrorFlash() {
  // TODO: the message should be managed to the view, so find a way to move it there eventually.
  yield put(
    showFlashNotice({
      message: 'Something is wrong with the server :(. Please, try again later.',
      variant: FlashNoticeVariant.error,
      autoHide: true,
    })
  )
}
